import { CONNECTED_PARTNERS_API_URL } from '../connected-partners';
import { globalQueryKeys } from '../global-query-keys';

export const PARTNERS_API_URL = 'ui/partner/partners';

export const OPERATOR_API_URL = 'ui/operator/partners';

export const PARTNERS_CUSTOMER_API_URL = '/ui/partner/monitoring/customers';

export const partnerCustomersQueryKeys = {
  all: [...globalQueryKeys.partnersConnections, CONNECTED_PARTNERS_API_URL],
};
